/**
 * Curated stock photo library for Immobilier Solaire.
 * All URLs are direct Unsplash CDN links (free for commercial use under the Unsplash License).
 * Verified working URLs as of May 2026.
 */

const make = (id, alt, tags, author) => ({
  id,
  alt,
  tags,
  author,
  url: `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1920&q=80`,
  thumb: `https://images.unsplash.com/${id}?auto=format&fit=crop&w=400&q=60`,
});

export const STOCK_LIBRARY = [
  // --- Industrial / warehouses ---
  make("photo-1586528116311-ad8dd3c8310d", "Bâtiment industriel acier et béton", ["industriel", "moderne", "construction"], "Carles Rabada"),
  make("photo-1581094288338-2314dddb7ece", "Quai de chargement extérieur", ["entrepot", "logistique", "quai", "industriel"], "Jacques Dillies"),
  make("photo-1525498128493-380d1990a112", "Intérieur d'entrepôt avec rayonnages", ["entrepot", "interieur", "logistique"], "Petrebels"),
  make("photo-1556761175-5973dc0f32e7", "Bâtiments d'activité en zone industrielle", ["industriel", "zone d'activite"], "Ricardo Gomez Angel"),
  make("photo-1487754180451-c456f719a1fc", "Architecture industrielle moderne acier", ["industriel", "moderne"], "Bernard Hermant"),
  make("photo-1530124566582-a618bc2615dc", "Hangar logistique extérieur", ["entrepot", "hangar", "industriel"], "Marcin Jozwiak"),
  make("photo-1601599963565-b7f49deb6f8c", "Façade entrepôt moderne", ["entrepot", "moderne", "industriel"], "Tom Fisk"),

  // --- Solar / photovoltaic ---
  make("photo-1509391366360-2e959784a276", "Panneaux solaires sur toit industriel", ["solaire", "photovoltaique", "energie"], "American Public Power Association"),
  make("photo-1466611653911-95081537e5b7", "Toiture photovoltaïque vue d'ensemble", ["solaire", "photovoltaique", "toiture"], "American Public Power Association"),
  make("photo-1497435334941-8c899ee9e8e9", "Champ de panneaux solaires", ["solaire", "photovoltaique", "energie"], "Andreas Gücklhorn"),
  make("photo-1545209463-e2825498edbf", "Détail toit photovoltaïque bleu", ["solaire", "photovoltaique"], "Eelco Böhtlingk"),
  make("photo-1559302504-64aae6ca6b6d", "Panneaux solaires lever de soleil", ["solaire", "photovoltaique", "energie"], "Mariana Proença"),
  make("photo-1611365892117-bce9c2625f72", "Ferme solaire moderne", ["solaire", "photovoltaique"], "Antonio Garcia"),

  // --- Aerial / drone ---
  make("photo-1568047574854-3d4d49b95e3a", "Vue aérienne zone d'activité", ["aerien", "drone", "zone industrielle"], "Pascal Bernardon"),
  make("photo-1545153996-d72e0adcef83", "Drone bâtiments toits gris", ["aerien", "drone", "industriel"], "Tom Fisk"),
  make("photo-1577415124269-fc1140a69e91", "Survol industrie campagne", ["aerien", "drone", "campagne"], "Tom Fisk"),
  make("photo-1473773508845-188df298d2d1", "Vue aérienne usine et toits", ["aerien", "drone", "industriel"], "Tom Fisk"),

  // --- Office / professional ---
  make("photo-1497366216548-37526070297c", "Bureau moderne professionnel", ["bureau", "moderne", "espace"], "Copernico"),
  make("photo-1497366754035-f200968a6e72", "Réunion professionnelle table", ["bureau", "professionnel", "team"], "Copernico"),
  make("photo-1521737711867-e3b97375f902", "Échange professionnels poignée main", ["bureau", "professionnel"], "Cytonn Photography"),
  make("photo-1554469384-e58fac16e23a", "Plan architectural sur table", ["bureau", "construction", "plan"], "Daniel McCullough"),

  // --- Construction ---
  make("photo-1503387762-592deb58ef4e", "Bâtiment en construction acier", ["construction", "chantier"], "Christopher Burns"),
  make("photo-1541888946425-d81bb19240f5", "Chantier construction grue", ["construction", "chantier"], "Pop & Zebra"),
  make("photo-1581094271901-8022df4466f9", "Charpente métallique intérieure", ["construction", "industriel"], "Jacques Dillies"),

  // --- France / countryside ---
  make("photo-1571055107559-3e67626fa8be", "Campagne française verte", ["france", "campagne", "loiret"], "Jonas Tebbe"),
  make("photo-1500077612-e21eb5b2c9bd", "Paysage rural France", ["france", "campagne"], "Léonard Cotte"),
  make("photo-1500382017468-9049fed747ef", "Ciel et terre agricole", ["france", "campagne", "ciel"], "Federico Respini"),
  make("photo-1572276596237-5db2c3e16c5d", "Champ français été", ["france", "campagne"], "Boris Smokrovic"),
];

export const STOCK_TAGS = [
  { value: "all", label: "Toutes" },
  { value: "industriel", label: "Industriel" },
  { value: "entrepot", label: "Entrepôt" },
  { value: "solaire", label: "Solaire" },
  { value: "aerien", label: "Vue aérienne" },
  { value: "bureau", label: "Bureau" },
  { value: "construction", label: "Construction" },
  { value: "france", label: "France" },
];
